// extracted by mini-css-extract-plugin
export default {"logo":"sideBar_logo__cg77h","appTitle":"sideBar_appTitle__iMyt+","menuContainer":"sideBar_menuContainer__PSZbR"};